import { useAsyncData, useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import type { NavigationItem } from '../types'
import { mapMenuItem } from '../utils/mapMenuItem'
import {
  SEASONAL_ITEM_IDS,
  buildSeasonalNavigationItems,
  filterSeasonalNavigationItems,
} from '../utils/seasonalNavigationItems'

import t from './useFetchNavigationItems.translations'

export function useFetchNavigationItems() {
  const $httpFetch = useHttpFetch()
  const i18n = useI18n()
  const locale = useI18nLocale().toLowerCase()

  const { data: mappedItems } = useAsyncData(
    'navigation-main-menu',
    () => $httpFetch('/bm/navigation/main'),
    {
      dedupe: 'defer',
      default: (): NavigationItem[] => [],
      transform: (data) => data.items.map((item) => mapMenuItem(item, locale)),
    },
  )

  const { features } = useMarketplace()

  const { FF_ENABLE_NAVIGATION_ITEMS_BY_SERVICE = false } =
    useRuntimeConfig().public

  const items = computed(() => {
    if (FF_ENABLE_NAVIGATION_ITEMS_BY_SERVICE) {
      return mappedItems.value
    }

    return filterSeasonalNavigationItems(
      [
        ...buildSeasonalNavigationItems({
          locale,
          titles: {
            [SEASONAL_ITEM_IDS.GOOD_DEALS]: i18n(t.goodDeals),
            [SEASONAL_ITEM_IDS.BLACK_FRIDAY]: i18n(t.blackFriday),
            [SEASONAL_ITEM_IDS.HOLIDAYS]: i18n(t.holidays),
          },
        }),
        ...mappedItems.value,
      ],
      { now: new Date(), features },
    )
  })

  return { items }
}
